import * as React from 'react'

import type {AgentPoolId} from '../../../../../../types'
import {useShowState} from '../../AgentPoolPage.hooks'
import DialogTrigger from '../../DialogTrigger/DialogTrigger'

import AssignAgentsDialog from './AssignAgentsDialog/AssignAgentsDialog'

type Props = {
  agentPoolId: AgentPoolId
  agentPoolName?: string
  className?: string | undefined
  agentsNumber: number
  maxAgentsNumber?: number | null
}

function AssignAgentsButton({
  agentPoolId,
  agentPoolName,
  className,
  agentsNumber,
  maxAgentsNumber,
}: Props): React.ReactElement {
  const [show, setShow, setHide] = useShowState()
  const disabled =
    maxAgentsNumber == null || (maxAgentsNumber > -1 && agentsNumber >= maxAgentsNumber)
  return (
    <DialogTrigger
      className={className}
      triggerTitle="Assign agents..."
      title={`Assign agents to ${agentPoolName}`}
      onShow={setShow}
      onHide={setHide}
      show={show}
      disabled={disabled}
    >
      <AssignAgentsDialog
        agentPoolId={agentPoolId}
        onCloseAttempt={setHide}
        agentsNumber={agentsNumber}
        maxAgentsNumber={maxAgentsNumber}
      />
    </DialogTrigger>
  )
}

export default React.memo(AssignAgentsButton)
